export const replaceKatexSigns = string => {
  return string
    .replaceAll('&amp;', '&')
    .replaceAll(/&lt;/g, '<')
    .replaceAll(/&gt;/g, '>')
    .replaceAll('&amp;', '&')
    .replaceAll('&nbsp;', ' ')
    .replaceAll('\\mleft', '\\left')
    .replaceAll('\\mright', '\\right')
    .replaceAll('\\placeholder{}', '\\square');
};

const FULL = {
  label: 'Math',
  layout: 'manual',
  rows: [
    [
      { class: '', latex: '\\parallel', width: 1 },
      { class: '', latex: '\\nparallel', width: 1 },
      { class: '', latex: '\\measuredangle', width: 1 },
      { class: '', latex: '\\pi', width: 1 },

      { label: '[separator]', width: 0.5 },

      {
        class: 'extra-small has-variant',
        tooltip: 'לחיצה ארוכה תפתח אפשרויות נוספות',
        latex:
          '{\\left\\{} \\begin{array}{c} {#0} \\\\ {#0} \\end{array} \\right',
        width: 1,
        variants: [
          {
            class: 'extra-small',
            latex:
              '{\\left\\{} \\begin{array}{c} {#0} \\\\ {#0} \\\\ {#0} \\end{array} \\right',
            width: 1,
          },
        ],
      },
      { class: 'extra-small', latex: '\\frac{#@}{#0}', width: 1 },

      { label: '[separator]', width: 0.5 },

      { class: 'symbol', label: '%', latex: '\\%', width: 1 },
      { class: 'digital', latex: '7', width: 1 },
      { class: 'digital', latex: '8', width: 1 },
      { class: 'digital', latex: '9', width: 1 },

      { class: 'symbol', latex: '\\div', width: 1 },
      { class: 'symbol', label: '⌫', width: 1, command: ['deleteBackward'] },
    ],
    [
      {
        class: 'has-variant',
        tooltip: 'לחיצה ארוכה תפתח אפשרויות נוספות',
        latex: '\\forall',
        width: 1,
        variants: [
          {
            latex: '\\vee',
            width: 1,
          },
          {
            latex: '\\wedge',
            width: 1,
          },
          {
            latex: '\\exists',
            width: 1,
          },
          {
            latex: '\\equiv',
            width: 1,
          },
          {
            latex: '\\cap',
            width: 1,
          },
          {
            latex: '\\cup',
            width: 1,
          },
        ],
      },
      { class: '', latex: '\\bot', width: 1 },
      { class: '', latex: '\\Delta', width: 1 },
      { class: '', latex: '\\alpha', width: 1 },

      { label: '[separator]', width: 0.5 },

      {
        class: 'extra-small has-variant',
        tooltip: 'לחיצה ארוכה תפתח אפשרויות נוספות',
        latex: '({#0})',
        width: 1,
        variants: [
          {
            latex: '\\{{#0}\\}',
            width: 1,
          },
          {
            latex: '|{#0}|',
            width: 1,
          },
          {
            latex: '[{#0}]',
            width: 1,
          },
        ],
      },
      { class: 'extra-small', latex: '\\bar{#0}', width: 1 },

      { label: '[separator]', width: 0.5 },

      {
        class: 'symbol has-variant',
        tooltip: 'לחיצה ארוכה תפתח אפשרויות נוספות',
        label: '√',
        latex: '\\sqrt{#0}',
        width: 1,
        variants: [
          {
            latex: '\\sqrt[3]{#0}',
            width: 1,
          },
        ],
      },
      { class: 'digital', latex: '4', width: 1 },
      { class: 'digital', latex: '5', width: 1 },
      { class: 'digital', latex: '6', width: 1 },

      { class: '', latex: '\\times', width: 1 },
      {
        class: 'has-variant',
        tooltip: 'לחיצה ארוכה תפתח אפשרויות נוספות',
        latex: '\\pm',
        width: 1,
        variants: [
          {
            latex: '\\mp',
            width: 1,
          },
        ],
      },
    ],
    [
      { class: '', latex: '\\iff', width: 1 },
      { class: '', latex: '^\\circ', width: 1 },
      { class: '', latex: '\\square', width: 1 },
      { class: '', latex: '\\beta', width: 1 },

      { label: '[separator]', width: 0.5 },

      {
        class: 'extra-small has-variant',
        tooltip: 'לחיצה ארוכה תפתח אפשרויות נוספות',
        latex:
          '\\[\\begin{array}{c} \\underbrace{#0}  \\\\ {#0} \\end{array} \\]',
        width: 1,
        variants: [
          {
            class: 'extra-small',
            latex:
              '\\[\\begin{array}{c} {#0} \\\\  \\overbrace{#0}  \\end{array} \\]',
            width: 1,
          },
        ],
      },
      { class: 'small', latex: '{#0}_{#0}', width: 1 },

      { label: '[separator]', width: 0.5 },

      { class: '', latex: '\\infty', width: 1 },
      { class: 'digital', latex: '1', width: 1 },
      { class: 'digital', latex: '2', width: 1 },
      { class: 'digital', latex: '3', width: 1 },
      { class: '', latex: '-', width: 1 },
      { class: '', latex: '\\geq', width: 1 },
    ],
    [
      { class: '', latex: '\\Downarrow', width: 1 },
      { class: '', latex: '\\leftarrow', width: 1 },
      { class: '', latex: '\\rightarrow', width: 1 },
      { class: '', latex: '\\gamma', width: 1 },

      { label: '[separator]', width: 0.5 },

      { class: 'small', latex: '{#0} / {#0}', width: 1 },
      {
        class: 'has-variant',
        tooltip: 'לחיצה ארוכה תפתח אפשרויות נוספות',
        latex: '\\vdots',
        width: 1,
        variants: [
          {
            latex: '\\cdots',
            width: 1,
          },
        ],
      },

      { label: '[separator]', width: 0.5 },

      {
        class: 'has-variant',
        tooltip: 'לחיצה ארוכה תפתח אפשרויות נוספות',
        latex: 'x',
        width: 1,
        variants: [
          {
            latex: 'y',
            width: 1,
          },
          {
            latex: 'z',
            width: 1,
          },
        ],
      },
      { class: 'digital', latex: '0', width: 1 },
      { class: '', latex: '.', width: 1 },
      {
        class: 'has-variant',
        tooltip: 'לחיצה ארוכה תפתח אפשרויות נוספות',
        latex: '=',
        width: 1,
        variants: [
          {
            latex: '\\ni',
            width: 1,
          },
          {
            latex: '\\neq',
            width: 1,
          },
          {
            latex: '\\cong',
            width: 1,
          },
          {
            latex: '\\approx',
            width: 1,
          },
          {
            latex: '\\sim',
            width: 1,
          },
        ],
      },
      { class: '', latex: '+', width: 1 },
      { class: '', latex: '\\leq', width: 1 },
    ],
  ],
};
const ADVANCED = {
  label: 'Math',
  layout: 'manual',
  rows: [
    [
      { class: '', latex: '\\parallel', width: 1 },
      { class: '', latex: '\\nparallel', width: 1 },
      { class: '', latex: '\\measuredangle', width: 1 },
      { class: '', latex: '\\pi', width: 1 },

      { label: '[separator]', width: 0.5 },

      {
        class: 'extra-small has-variant',
        tooltip: 'לחיצה ארוכה תפתח אפשרויות נוספות',
        latex:
          '{\\left\\{} \\begin{array}{c} {#0} \\\\ {#0} \\end{array} \\right',
        width: 1,
        variants: [
          {
            class: 'extra-small',
            latex:
              '{\\left\\{} \\begin{array}{c} {#0} \\\\ {#0} \\\\ {#0} \\end{array} \\right',
            width: 1,
          },
        ],
      },
      { class: 'extra-small', latex: '\\frac{#@}{#0}', width: 1 },

      { label: '[separator]', width: 0.5 },

      { class: 'symbol', label: '%', latex: '\\%', width: 1 },
      { class: 'digital', latex: '7', width: 1 },
      { class: 'digital', latex: '8', width: 1 },
      { class: 'digital', latex: '9', width: 1 },

      { class: 'symbol', latex: '\\div', width: 1 },
      { class: 'symbol', label: '⌫', width: 1, command: ['deleteBackward'] },
    ],
    [
      {
        class: 'has-variant',
        tooltip: 'לחיצה ארוכה תפתח אפשרויות נוספות',
        latex: '\\forall',
        width: 1,
        variants: [
          {
            latex: '\\vee',
            width: 1,
          },
          {
            latex: '\\wedge',
            width: 1,
          },
          {
            latex: '\\exists',
            width: 1,
          },
          {
            latex: '\\equiv',
            width: 1,
          },
          {
            latex: '\\cap',
            width: 1,
          },
          {
            latex: '\\cup',
            width: 1,
          },
        ],
      },
      { class: '', latex: '\\bot', width: 1 },
      { class: '', latex: '\\Delta', width: 1 },
      { class: '', latex: '\\alpha', width: 1 },

      { label: '[separator]', width: 0.5 },

      {
        class: 'extra-small has-variant',
        tooltip: 'לחיצה ארוכה תפתח אפשרויות נוספות',
        latex: '({#0})',
        width: 1,
        variants: [
          {
            latex: '\\{{#0}\\}',
            width: 1,
          },
          {
            latex: '|{#0}|',
            width: 1,
          },
          {
            latex: '[{#0}]',
            width: 1,
          },
        ],
      },
      { class: 'extra-small', latex: '\\bar{#0}', width: 1 },

      { label: '[separator]', width: 0.5 },

      {
        class: 'symbol has-variant',
        tooltip: 'לחיצה ארוכה תפתח אפשרויות נוספות',
        label: '√',
        latex: '\\sqrt{#0}',
        width: 1,
        variants: [
          {
            latex: '\\sqrt[3]{#0}',
            width: 1,
          },
        ],
      },
      { class: 'digital', latex: '4', width: 1 },
      { class: 'digital', latex: '5', width: 1 },
      { class: 'digital', latex: '6', width: 1 },

      { class: '', latex: '\\times', width: 1 },
      {
        class: 'has-variant',
        tooltip: 'לחיצה ארוכה תפתח אפשרויות נוספות',
        latex: '\\pm',
        width: 1,
        variants: [
          {
            latex: '\\mp',
            width: 1,
          },
        ],
      },
    ],
    [
      { class: '', latex: '\\iff', width: 1 },
      { class: '', latex: '^\\circ', width: 1 },
      { class: '', latex: '\\square', width: 1 },
      { class: '', latex: '\\beta', width: 1 },

      { label: '[separator]', width: 1.5 },
      { class: 'small', latex: '{#0}_{#0}', width: 1 },

      { label: '[separator]', width: 0.5 },

      { class: '', latex: '\\infty', width: 1 },
      { class: 'digital', latex: '1', width: 1 },
      { class: 'digital', latex: '2', width: 1 },
      { class: 'digital', latex: '3', width: 1 },
      { class: '', latex: '-', width: 1 },
      { class: '', latex: '\\geq', width: 1 },
    ],
    [
      { class: '', latex: '\\Downarrow', width: 1 },
      { class: '', latex: '\\leftarrow', width: 1 },
      { class: '', latex: '\\rightarrow', width: 1 },
      { class: '', latex: '\\gamma', width: 1 },

      { label: '[separator]', width: 1 },

      { label: '[separator]', width: 2 },

      {
        class: 'has-variant',
        tooltip: 'לחיצה ארוכה תפתח אפשרויות נוספות',
        latex: 'x',
        width: 1,
        variants: [
          {
            latex: 'y',
            width: 1,
          },
          {
            latex: 'z',
            width: 1,
          },
        ],
      },
      { class: 'digital', latex: '0', width: 1 },
      { class: '', latex: '.', width: 1 },
      {
        class: 'has-variant',
        tooltip: 'לחיצה ארוכה תפתח אפשרויות נוספות',
        latex: '=',
        width: 1,
        variants: [
          {
            latex: '\\ni',
            width: 1,
          },
          {
            latex: '\\neq',
            width: 1,
          },
          {
            latex: '\\cong',
            width: 1,
          },
          {
            latex: '\\approx',
            width: 1,
          },
          {
            latex: '\\sim',
            width: 1,
          },
        ],
      },
      { class: '', latex: '+', width: 1 },
      { class: '', latex: '\\leq', width: 1 },
    ],
  ],
};

const MEDIUM = {
  label: 'Math',
  layout: 'manual',
  rows: [
    [
      { class: '', latex: '^\\circ', width: 1 },
      { class: '', latex: '\\square', width: 1 },

      { class: '', latex: '\\measuredangle', width: 1 },
      { latex: '\\cong', width: 1 },
      { class: '', latex: '\\pi', width: 1 },

      { label: '[separator]', width: 0.5 },

      {
        latex: '\\{{#0}\\}',
        width: 1,
      },
      { class: 'extra-small', latex: '\\frac{#@}{#0}', width: 1 },

      { label: '[separator]', width: 0.5 },

      { class: 'symbol', label: '%', latex: '\\%', width: 1 },
      { class: 'digital', latex: '7', width: 1 },
      { class: 'digital', latex: '8', width: 1 },
      { class: 'digital', latex: '9', width: 1 },

      { class: 'symbol', latex: '\\div', width: 1 },
      { class: 'symbol', label: '⌫', width: 1, command: ['deleteBackward'] },
    ],
    [
      { class: '', latex: '\\iff', width: 1 },

      { class: '', latex: '\\bot', width: 1 },
      { class: '', latex: '\\Delta', width: 1 },
      {
        latex: '\\approx',
        width: 1,
      },
      { class: '', latex: '\\alpha', width: 1 },

      { label: '[separator]', width: 0.5 },

      {
        class: 'extra-small',
        latex:
          '{\\left\\{} \\begin{array}{c} {#0} \\\\ {#0} \\end{array} \\right',
        width: 1,
      },
      { class: '', latex: '\\bar{#0}', width: 1 },

      { label: '[separator]', width: 0.5 },

      {
        class: 'symbol has-variant',
        tooltip: 'לחיצה ארוכה תפתח אפשרויות נוספות',
        label: '√',
        latex: '\\sqrt{#0}',
        width: 1,
        variants: [
          {
            latex: '\\sqrt[3]{#0}',
            width: 1,
          },
        ],
      },
      { class: 'digital', latex: '4', width: 1 },
      { class: 'digital', latex: '5', width: 1 },
      { class: 'digital', latex: '6', width: 1 },

      { class: '', latex: '\\times', width: 1 },
      { class: '', latex: '\\pm', width: 1 },
    ],
    [
      { class: '', latex: '\\Downarrow', width: 1 },
      { class: '', latex: '\\parallel', width: 1 },
      { class: '', latex: '\\nparallel', width: 1 },
      { latex: '\\sim', width: 1 },
      { class: '', latex: '\\beta', width: 1 },

      { label: '[separator]', width: 0.5 },
      {
        class: 'extra-small',
        latex:
          '{\\left\\{} \\begin{array}{c} {#0} \\\\ {#0} \\\\ {#0} \\end{array} \\right',
        width: 1,
      },
      {
        latex: '|{#0}|',
        width: 1,
      },
      { label: '[separator]', width: 0.5 },

      {
        class: 'has-variant',
        tooltip: 'לחיצה ארוכה תפתח אפשרויות נוספות',
        latex: 'x',
        width: 1,
        variants: [
          {
            latex: 'y',
            width: 1,
          },
          {
            latex: 'z',
            width: 1,
          },
        ],
      },
      { class: 'digital', latex: '1', width: 1 },
      { class: 'digital', latex: '2', width: 1 },
      { class: 'digital', latex: '3', width: 1 },
      { class: '', latex: '-', width: 1 },
      { class: '', latex: '\\geq', width: 1 },
    ],
    [
      { label: '[separator]', width: 1 },
      { label: '[separator]', width: 1 },
      { class: '', latex: '\\leftarrow', width: 1 },
      { class: '', latex: '\\rightarrow', width: 1 },
      { class: '', latex: '\\gamma', width: 1 },

      { label: '[separator]', width: 0.5 },

      { class: '', latex: '({#0})', width: 1 },

      {
        latex: '[{#0}]',
        width: 1,
      },

      { label: '[separator]', width: 0.5 },
      {
        latex: '\\neq',
        width: 1,
      },
      { class: 'digital', latex: '0', width: 1 },
      { class: '', latex: '.', width: 1 },
      { class: '', latex: '=', width: 1 },
      { class: '', latex: '+', width: 1 },
      { class: '', latex: '\\leq', width: 1 },
    ],
  ],
};

const BASIC = {
  label: 'Math',
  layout: 'manual',
  rows: [
    [
      { class: '', latex: '^\\circ', width: 1 },
      { class: '', latex: '\\square', width: 1 },

      { class: '', latex: '\\measuredangle', width: 1 },
      { class: '', latex: '\\pi', width: 1 },

      { label: '[separator]', width: 0.5 },

      {
        latex: '\\{{#0}\\}',
        width: 1,
      },
      { class: 'extra-small', latex: '\\frac{#@}{#0}', width: 1 },

      { label: '[separator]', width: 0.5 },

      { class: 'symbol', label: '%', latex: '\\%', width: 1 },
      { class: 'digital', latex: '7', width: 1 },
      { class: 'digital', latex: '8', width: 1 },
      { class: 'digital', latex: '9', width: 1 },

      { class: 'symbol', latex: '\\div', width: 1 },
      { class: 'symbol', label: '⌫', width: 1, command: ['deleteBackward'] },
    ],
    [
      { class: '', latex: '\\iff', width: 1 },

      { class: '', latex: '\\bot', width: 1 },
      { class: '', latex: '\\Delta', width: 1 },

      { class: '', latex: '\\alpha', width: 1 },

      { label: '[separator]', width: 0.5 },

      { class: '', latex: '({#0})', width: 1 },
      {
        latex: '|{#0}|',
        width: 1,
      },

      { label: '[separator]', width: 0.5 },

      {
        class: 'symbol has-variant',
        tooltip: 'לחיצה ארוכה תפתח אפשרויות נוספות',
        label: '√',
        latex: '\\sqrt{#0}',
        width: 1,
        variants: [
          {
            latex: '\\sqrt[3]{#0}',
            width: 1,
          },
        ],
      },
      { class: 'digital', latex: '4', width: 1 },
      { class: 'digital', latex: '5', width: 1 },
      { class: 'digital', latex: '6', width: 1 },

      { class: '', latex: '\\times', width: 1 },
      { class: '', latex: '\\pm', width: 1 },
    ],
    [
      { class: '', latex: '\\Downarrow', width: 1 },
      { class: '', latex: '\\parallel', width: 1 },
      { class: '', latex: '\\nparallel', width: 1 },

      { class: '', latex: '\\beta', width: 1 },

      { label: '[separator]', width: 0.5 },
      { label: '[separator]', width: 1 },

      {
        latex: '[{#0}]',
        width: 1,
      },
      { label: '[separator]', width: 0.5 },

      {
        class: 'has-variant',
        tooltip: 'לחיצה ארוכה תפתח אפשרויות נוספות',
        latex: 'x',
        width: 1,
        variants: [
          {
            latex: 'y',
            width: 1,
          },
          {
            latex: 'z',
            width: 1,
          },
        ],
      },
      { class: 'digital', latex: '1', width: 1 },
      { class: 'digital', latex: '2', width: 1 },
      { class: 'digital', latex: '3', width: 1 },
      { class: '', latex: '-', width: 1 },
      { class: '', latex: '\\geq', width: 1 },
    ],
    [
      { label: '[separator]', width: 1 },
      { label: '[separator]', width: 1 },
      { label: '[separator]', width: 1 },

      { class: '', latex: '\\gamma', width: 1 },

      { label: '[separator]', width: 0.5 },

      { label: '[separator]', width: 1 },
      { label: '[separator]', width: 1 },

      { label: '[separator]', width: 0.5 },
      {
        latex: '\\neq',
        width: 1,
      },
      { class: 'digital', latex: '0', width: 1 },
      { class: '', latex: '.', width: 1 },
      { class: '', latex: '=', width: 1 },
      { class: '', latex: '+', width: 1 },
      { class: '', latex: '\\leq', width: 1 },
    ],
  ],
};

export const CUSTOM_KEYBOARDS = {
  FULL,
  ADVANCED,
  MEDIUM,
  BASIC,
};
